import { useEffect } from "react";
import moment from "moment";
import { ArticleModalContent } from "common";
import { useNewsModalContent } from "./hooks";

import { convertRawToHtml, generateImageLink } from "utils";
import { useParams } from "react-router-dom";

export interface NewsModalContentProps {
  setCurrentNewsId: (value: number | string) => void;
}

export const NewsModalContent = ({
  setCurrentNewsId,
}: NewsModalContentProps) => {
  const { id } = useParams();
  const { newsContent } = useNewsModalContent({ id: Number(id) });

  useEffect(() => {
    if (id) setCurrentNewsId(id);
  }, [id]);

  return (
    <ArticleModalContent
      type='News'
      sliderContent={newsContent}
      image={generateImageLink({ imageId: newsContent?.cover_image })}
      date={moment(newsContent?.created_at).format("DD.MM.YYYY")}
      title={newsContent?.title}
      text={convertRawToHtml(newsContent?.content)}
    />
  );
};
